import { getInitialState, reduce as reduceLoadingStateMachine, } from "@single-js/common/util/loading-state-machine";
const initialState = {
    licenseInfo: getInitialState(),
};
export function licenseReducer(state = initialState, action) {
    switch (action.type) {
        case "LICENSE_INFO":
            {
                state = {
                    ...state,
                    licenseInfo: reduceLoadingStateMachine(state.licenseInfo, action),
                };
            }
            break;
    }
    return state;
}
